import api from './axios';

export const sendOtp = (data) =>
  api.post('/user/send-otp', data).then((r) => r.data);

export const verifyOtp = (data) =>
  api.post('/user/verify-otp', data).then((r) => r.data);

export const register = (data) =>
  api.post('/user/register', data).then((r) => r.data.data);

export const login = (data) =>
  api.post('/user/login', data).then((r) => r.data.data);

export const getMe = () =>
  api.get('/user/me').then((r) => r.data.data.user);

export const updateProfile = (data) =>
  api.put('/user/profile', data).then((r) => r.data.data.user);

export const changePassword = (data) =>
  api.put('/user/change-password', data).then((r) => r.data);

export const forgotPassword = (email) =>
  api.post('/user/forgot-password', { email }).then((r) => r.data);

export const resetPassword = (data) =>
  api.post('/user/reset-password', data).then((r) => r.data);
